import React, { useContext, useEffect, useState } from 'react';
import { objConfig } from 'components/shared/atoms/CustomSelect/CustomSelect';
import { BookingContext } from 'context/BookingContext';
import Select from 'react-select'
import { Form, Col, Row, Spinner } from 'react-bootstrap';
import { getZoneByPostCode } from 'services/postcode';

const HomeCollectionProduct = (props) => {
    const [filteredOptions, setFilteredOptions] = useState([])
    const [items, setItems] = useState([])
    const [show, setShow] = useState(false)
    const _BookingContext = useContext(BookingContext)
    const [ lastStateBookingContext, setlastStateBookingContext ] = useState(_BookingContext)
    const controller = new AbortController()
    const [selected, setSelected] = useState([])

    const styles = {
        control: (provided, state) => ({
            ...provided,
            flexWrap: 'wrap',
            minHeight: '40px',
            padding: '12px 0px 12px 0px',
            borderRadius: '4px',
            overflow: 'hidden',
            border: `${props.error ? '2px solid #dc3545' : '1px solid #77878A'} !important`,
            boxShadow: state.isFocused ? '0 0 0 0.1rem #5eb5c1' : styles.boxShadow,
            color: props.errors ? '#dc3545' : '#000000'
        }),
    
        multiValue: (provided) => ({
            ...provided,
            padding: '10px',
            backgroundColor: '#4F868E',
            borderRadius: '4px',
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#ffffff',
            width: '100%',
            justifyContent: 'space-between'
        }),
    
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#ffffff',
        }),
    
        option: (provided, state) => ({
            ...provided,
            padding: '10px 20px',
            backgroundColor: (state.isFocused || state.isSelected) ? '#5eb5c1' : provided.backgroundColor,
            cursor: 'pointer',
        }),
    }

    useEffect(() => {
        displayHomeCollectionProduct('default')
    },[])

    useEffect(() => {
        displayHomeCollectionProduct();
        setlastStateBookingContext(_BookingContext);

        // Notify parent component about filteredOptions
        props.onFilteredOptionsChange && props.onFilteredOptionsChange(filteredOptions);

        return () => {
            controller.abort();
        };
    }, [_BookingContext, filteredOptions])

    function displayHomeCollectionProduct(state) {
        const addressType = {
            'customer_address': {
                current: _BookingContext.owner.address, 
                last: lastStateBookingContext.owner.address
            },
            'postal_address': {
                current: _BookingContext.collectionDetails.collectionAddress, 
                last: lastStateBookingContext.collectionDetails.collectionAddress
            }
        }

        const collectionAddressOption = _BookingContext.collectionDetails.collectionAddressOption
        const lastCollectionAddressOption = lastStateBookingContext.collectionDetails.collectionAddressOption
        const address = addressType[collectionAddressOption]?.current
        const lastAddress = addressType[collectionAddressOption]?.last
        const skip = _BookingContext.skip
        const lastSkip = lastStateBookingContext.skip

        

        if(
            state === 'default' ||
            skip !== lastSkip ||
            lastCollectionAddressOption !== collectionAddressOption || 
            JSON.stringify(address) !== JSON.stringify(lastAddress)
        ) {
            if(address?.lat) {
                getZoneByPostCode({
                    postalcode: address.postalcode,
                    city: address.city
                })
                .then((res) => {
                    const options = res.data

                    if (
                        res.data &&
                        options) {
                        setItems(() => transformOptions(options))
                        setFilteredOptions(() => options)
                        setShow(true)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            } else {
                setShow(false)
            }
        }
    }

    function transformOptions(options) {
        return options.map(option => {
            option.packageProductsC = null
            option.quantity = 1
            option.actualProductIdC = option.id
            option.packageProductsC = null
            option.engravingText = null
            option.editId = null
            option.isVpcreated = 1
            option.home_collection_product = true
            option.editId = option.id
            option.id = null

            return option
        })
    }

    function onChangeOption(value) {
        _BookingContext.setState(prev => {
            return {
                ...prev,
                collectionDetails: {
                    ...prev.collectionDetails,
                    collectionProducts: [value]
                }
            }
        })
    }

    function searchItems(e) {
        const filtered = items.filter((item) => (
            item.name.toLowerCase().includes(e.toLowerCase())
        ))

        setFilteredOptions(filtered)
    }

    return (
        <>
            {
                show && filteredOptions?.length > 0 ? (
                    <Row className="mx-0 mb-2">
                        <Col className="pl-0" lg={6}>
                            <Form.Group as={Col} controlId="email" className="control-group">
                                <Form.Label className={props.error ? 'is-invalid' : ''}>COLLECTION TYPE *</Form.Label>
                                <Select
                                    classNamePrefix="custom-select"
                                    isSearchable
                                    options={filteredOptions}
                                    getOptionLabel={option => option.name}
                                    value={_BookingContext.collectionDetails.collectionProducts}
                                    onChange={onChangeOption}
                                    onInputChange={searchItems}
                                    components={objConfig.components}
                                    styles={styles}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                ) : null
            }
        </>
        
    )
}

export default HomeCollectionProduct

